import { useEffect } from "react";
import { lazy, Suspense } from "react";
import "./App.css";

import { SectionHero } from "./sections/SectionHero";
import { SectionSponsors } from "./sections/SectionSponsors";
import { SectionKategori } from "./sections/SectionKategori";
import { SectionInformation } from "./sections/SectionInformation";
import { SectionFAQ } from "./sections/SectionFAQ";
import { SectionDate } from "./sections/SectionDate";

// Missing components commented out
// const SectionWelcome = lazy(() =>
//   import("./sections").then((module) => ({ default: module.SectionWelcome }))
// );
// const SectionDate = lazy(() =>
//   import("./sections").then((module) => ({ default: module.SectionDate }))
// );

const Beranda = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {/* Above-the-fold: Langsung dirender */}
      <SectionHero />
      {/* Below-the-fold: Dimuat secara asinkronus */}
      <Suspense fallback={null}>
        <SectionDate />
        <SectionKategori />
        <SectionInformation />
   {/*      <SectionFAQ /> */}
     {/*    <SectionSponsors /> */}
        {/*         <SectionSupport /> */}
      </Suspense>
    </div>
  );
};

export default Beranda;
